module.exports = __webpack_public_path__ + "static/img/java-task.0841fb8d.svg";